import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { restartCssAnimations } from "../utils/restart_css_animations"

export default class extends Controller {
  open(event) {
    if (document.querySelector('.kanban-card--dragging')) return

    event.preventDefault()
    event.stopPropagation()

    const link = event.currentTarget
    const url = link.href || link.dataset.modalUrl
    if (!url) return

    const modalEl = document.getElementById('taskModal')
    if (!modalEl) return

    const frame = document.getElementById('task_modal')
    if (frame) {
      // Always show a fresh loading shell before fetch — avoids stale previous
      // task content and gives Safari a new spinner node after display:none.
      this._resetLoadingFrame(frame)
      frame.src = url
    }

    const modal = Modal.getOrCreateInstance(modalEl)

    const onShown = (event) => {
      if (event.target !== modalEl) return
      modalEl.removeEventListener('shown.bs.modal', onShown)
      // Restart spinner after the modal is visible — Safari won't animate
      // nodes that were created/kept while the parent was display:none.
      restartCssAnimations(modalEl)
    }
    modalEl.addEventListener('shown.bs.modal', onShown)

    modal.show()

    const onHidden = (event) => {
      // Guard against bubbled events from nested modals (e.g. #quoteRequestModal).
      if (event.target !== modalEl) return

      modalEl.removeEventListener('hidden.bs.modal', onHidden)
      modalEl.removeEventListener('shown.bs.modal', onShown)

      if (frame) {
        frame.removeAttribute('src')
        this._resetLoadingFrame(frame)
      }
    }

    modalEl.addEventListener('hidden.bs.modal', onHidden)
  }

  _resetLoadingFrame(frame) {
    const template = document.getElementById('task-modal-loading-template')
    frame.innerHTML = template?.innerHTML ?? ''
  }
}
